import { render, staticRenderFns } from "./IdentitySelect.vue?vue&type=template&id=0fa12c26&scoped=true"
import script from "./IdentitySelect.vue?vue&type=script&lang=js"
export * from "./IdentitySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa12c26",
  null
  
)

export default component.exports